<app-system-page-layout>
  <ng-container header-subtitle>
    {{'pages.systemPois.subtitle' | transloco}}
  </ng-container>
  <ng-container content>
    <app-system-cities-list (tileClicked)="selectCity($event)"></app-system-cities-list>
  </ng-container>
</app-system-page-layout>
